import exportController from './ExportStoriesController';
import exportTemplate from './export.plain.html';
import exportList from './export-list/exportList';

const module = angular.module('websked.stories.export', []);

const toLoad = [
  exportController,
  exportList
];

toLoad.forEach(fn => fn(module));

function routes($stateProvider) {
  $stateProvider
    .state('export', {
      abstract: true,
      url: '/export?{plan:any}&{starting}&{ending}&{searchType}&{term}&{child_plans}&{pitchesOnly}&{pi}&{ws}&{ps}&{ct}&{size}',
      template: '<div ui-view></div>'
    })
    .state('export.plain', {
      url: '/list',
      template: exportTemplate,
      controller: 'ExportStoriesController',
      data: {
        pageTitle: {
          de: 'Exportieren',
          en: 'Export',
          es: 'Exportarlo',
          fr: 'Exporter'
        }
      }
    });
}

module.config([
  '$stateProvider',
  routes
]);
